import { gql } from '@apollo/client';

export const migrateShiftTurnoverNotes = gql`
  mutation migrateShiftTurnoverNotes($shiftTurnoverId: String) {
    migrateShiftTurnoverNotes(shiftTurnoverId: $shiftTurnoverId) {
      value
    }
  }
`;
